import { useMutation } from 'react-query';
import { getPrivateApi } from '../../../../services/api';

export function useXeroExportCreditMemo() {
  return useMutation(async (creditLedgerEntryId: string) => {
    const api = getPrivateApi();

    return api.xeroExportCreditMemo({
      xeroExportCreditMemoRequest: {
        creditLedgerEntryId,
      },
    });
  });
}
